import { render } from "./AssignedContracts.vue?vue&type=template&id=32ef2e3e&scoped=true&ts=true"
import script from "./AssignedContracts.vue?vue&type=script&lang=ts"
export * from "./AssignedContracts.vue?vue&type=script&lang=ts"

import "./AssignedContracts.vue?vue&type=style&index=0&id=32ef2e3e&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ef2e3e"]])

export default __exports__